import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { JobDropdownComponentConfigurator } from './job-dropdown-component.configurator';
import { BaseComboboxDropdownComponent } from '@pl/pl-lib/forms';
import { Job } from 'src/app/core/models/job';

@Component({
  selector: 'app-job-searchable-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/combobox-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/combobox-dropdown.component.scss'
  ]
})
export class JobSearchableDropdownComponent extends BaseComboboxDropdownComponent<Job> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new JobDropdownComponentConfigurator();
  }
}
